
<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="title"
    (nzOnCancel)="handleCancel()"
    [nzFooter]="null"
    nzWidth="700px">
    
    <ng-container *nzModalContent>
        <nz-breadcrumb style="margin-bottom: 16px;">
            @for (crumb of breadcrumbs; track $index) {
                <nz-breadcrumb-item>
                    <a (click)="navigateToBreadcrumb($index, crumb)">{{ crumb.name }}</a>
                </nz-breadcrumb-item>
            }
            
        </nz-breadcrumb>

        <nz-table #basicTable [nzData]="files" [nzLoading]="loading" [nzPageSize]="8" nzSize="small">
            <thead>
                <tr>
                    <th nzWidth="40px"></th> 
                    <th>Name</th>
                    <th nzAlign="center" nzWidth="100px">Action</th>
                </tr>
            </thead>
            <tbody>
                @for (item of basicTable.data; track item.id) {
                    <tr>
                        <td nzAlign="center">
                            <span nz-icon [nzType]="isFolder(item.mimeType) ? 'folder' : 'file'" 
                                [nzTheme]="isFolder(item.mimeType) ? 'twotone' : 'outline'" 
                                nzTwotoneColor="#1890ff"></span>
                        </td>
                        
                        <td>
                            @if (isFolder(item.mimeType)) {
                                <a (click)="openFolder(item)" style="font-weight: 500;">
                                    {{ item.name }}
                                </a>
                            } @else {
                                <span>{{ item.name }}</span>
                            }
                        </td>

                        <td nzAlign="center">
                            @if (isFolder(item.mimeType)) {
                                <button nz-button nzType="default" nzSize="small" (click)="openFolder(item)">
                                    Open
                                </button>
                            } @else {
                                <button nz-button nzType="primary" nzSize="small" (click)="selectFile(item)">
                                    Select
                                </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    </ng-container>
</nz-modal>